import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customSearch',
    standalone: false
})
export class CustomSearchPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) return [];
        if (!searchText) return items;
    
        searchText = searchText.toLowerCase();
    
        return items.filter(item => {
          // Ensure item is a string and not null or undefined
          return item.applicationName.toLowerCase().includes(searchText);
        });
    }    
}